import { QueryParamsType } from "src/types/query-params";
import { useSwrRequest } from "../useSwrRequest";
import qs from "qs";
import useRequest from "../useRequest";

export const useCategories = (query: Record<string, QueryParamsType>) => {
  const url = `/categories?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    categories: (data as any[]) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
